<template>
  <div id="payDraw"></div>
</template>
<script>
var chart;
export default {
  data() {
    return { myData: [], series: [] };
  },
  methods: {
    reachData(data, alarmNames, colors) {
      this.series = [];
      for (let i = 0; i < alarmNames.length; i++) {
        this.series.push({
          type: "bar", 
          showBackground: true,
          backgroundStyle: {
            color: colors[i],
            opacity: 0.3,
          },
          color: colors[i]
        })
      }
      this.myData = [["报警类型", ...alarmNames]];
      for (var i = 0; i < data.length; i++) {
        data[i].date = this.utils.time(data[i].date, "mmdd");
        var arr = ["", 0, 0, 0];
        for (const j in data[i].alarmList) {
          arr[0] = data[i].date;
          var aa = data[i].alarmList[j].alarmTypeName;
          var index = this.myData[0].indexOf(aa);

          if (index != -1) {
            arr[index] = data[i].alarmList[j].num;
          }
        }
        this.myData.push(arr);
      }
      this.draw();
    },
    draw(id) {
      var that = this;
      this.chart = this.echarts.init(document.getElementById('payDraw'));
      this.option = {
        backgroundColor: "",
        /* title: {
          text: "车辆状况看板"
        }, */
        grid: {
          x: 30,
          y: 60,
          x2: 10,
          y2: 60, //距离下边的距离
        },
        legend: {
          left: 10, //图例组件离右边的距离
          // orient: "vertical", //布局  纵向布局
          orient: "horizontal", //布局  纵向布局
          width: 650, //图行例组件的宽度,默认自适应
          x: "top", //图例显示在右边
          itemWidth: 10, //图例标记的图形宽度
          itemHeight: 10, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#dataModal",
            fontSize: 12,
          },
        },
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return (
              val.seriesName + "（" + val.value[val.seriesIndex + 1] + "次）"
            );
          },
        },
        dataset: {
          source: this.myData,
        },
        xAxis: { type: "category", axisLabel: { rotate: 45 } },
        yAxis: {},
        series: this.series,
      };
      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  //调用
  mounted() {
    //this.drawBar("olinow");
    //this.draw();
  },
  destroyed() { },
};
</script>
<style lang="">
#payDraw {
  width: calc(100% - 20px);
  height: 300px;
  overflow: auto;
  background: #d4dfe9;
  margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/baojing/draw.vue